import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "ai-input" }
const _hoisted_2 = { class: "ai-input-header" }
const _hoisted_3 = { class: "ai-input-header-left" }
const _hoisted_4 = { class: "tips-popover" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "ai-input-header-right" }
const _hoisted_8 = {
  key: 0,
  class: "ri-color-filter-ai-line"
}
const _hoisted_9 = { class: "hot-content" }
const _hoisted_10 = {
  key: 0,
  class: "ri-file-copy-2-line"
}
const _hoisted_11 = { class: "copywriting-content" }
const _hoisted_12 = { class: "ai-input-footer" }
const _hoisted_13 = { class: "ai-input-footer-left" }
const _hoisted_14 = {
  key: 0,
  class: "ri-translate-2"
}
const _hoisted_15 = { class: "translation-content" }
const _hoisted_16 = {
  key: 0,
  class: "ri-brush-ai-line"
}
const _hoisted_17 = { class: "edit-options" }
const _hoisted_18 = { class: "ai-input-footer-right" }
const _hoisted_19 = { class: "ai-input-footer-title" }

import PolishAreaContent from './components/PolishAreaContent.vue';
import HotContentArea from './components/HotContentArea.vue';
import CopywritingArea from './components/CopywritingArea.vue';
import TranslationArea from './components/TranslationArea.vue';
import { ref, computed } from 'vue';

interface InputProps {
  modelValue?: string | number;
  type?: string;
  placeholder?: string;
  disabled?: boolean;
  maxlength?: number;
  rows?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: { default: '' },
    type: { default: 'textarea' },
    placeholder: { default: '' },
    disabled: { type: Boolean, default: false },
    maxlength: { default: undefined },
    rows: { default: 10 }
  },
  emits: ["update:modelValue", "focus", "blur", "input"],
  setup(__props: any, { emit: __emit }) {

const hotContentAreaRef = ref<InstanceType<typeof HotContentArea> | null>(null); // 热点创作区域
const polishAreaContentRef = ref<InstanceType<typeof PolishAreaContent> | null>(null); // 润色区域
const copywritingAreaRef = ref<InstanceType<typeof CopywritingArea> | null>(null); // 文案仿写区域
const translationAreaContentRef = ref<InstanceType<typeof TranslationArea> | null>(null); // 翻译区域

// 小技巧列表数据
const tipsList = ref([
  {
    title: '润色技巧',
    content: '选择一段合适的文案，点击润色按钮，即可生成更符合要求的文案。'
  },
  {
    title: '翻译',
    content: '确认文案没有问题后，点击翻译按钮可以翻译所需要的语言，即可生成更符合要求的文案。'
  },
  {
    title: 'ai创作',
    content: '若现有文案不尽如人意，轻点AI创作按钮，便能迅速获得更加精准、符合您期待的文案内容'
  },
  {
    title: '文案仿写',
    content: '输入抖音或者其他视频链接，AI将为您生成风格相似但内容不同的文案'
  }
]);

const props = __props;

const emit = __emit;

const inputPropsValue = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val as string),
});

// 计算文本长度
const textLength = computed(() => {
  return typeof inputPropsValue.value === 'string' ? inputPropsValue.value.length : 0;
});

// 计算阅读时间（按每4个字/秒计算，向上取整）
const readingTime = computed(() => {
  return Math.ceil(textLength.value / 4);
});

const polishAreaLoading = ref(false); // 润色区域loading
const hotAreaLoading = ref(false); // 热点创作loading
const copywritingAreaLoading = ref(false); // 文案仿写loading
const translationAreaLoading = ref(false); // 翻译区域loading
const copywritingPopoverVisible = ref(false); // 文案仿写弹窗可见性

// 输入框聚焦
const handleFocus = (event: FocusEvent) => {
  emit('focus', event);
};

// 输入框失去焦点
const handleBlur = (event: FocusEvent) => {
  emit('blur', event);
};

// 输入框输入
const handleInput = (value: string | number | null) => {
  emit('input', value as string);
};

// 显示热点创作区域
const handleShowHotContentArea = () => {
  if (hotContentAreaRef.value) {
    hotContentAreaRef.value.fetchHotList();
  }
};

// 隐藏热点创作区域 
const handleHideHotContentArea = () => {
  // 可以添加隐藏时的逻辑
  if (hotContentAreaRef.value) {
    hotContentAreaRef.value.close();
  }
};

// 显示润色区域
const handleShowPolishArea = () => {
  if (polishAreaContentRef.value) {
    polishAreaContentRef.value.show(inputPropsValue.value as string);
  }
};

// 隐藏润色区域
const handleHidePolishArea = () => {
  if (polishAreaContentRef.value) {
    polishAreaContentRef.value.hide();
  }
};

// 显示翻译区域
const handleShowTranslationArea = () => {
  if (translationAreaContentRef.value) {
    translationAreaContentRef.value.show(inputPropsValue.value as string);
  }
};

// 隐藏翻译区域
const handleHideTranslationArea = () => {
  if (translationAreaContentRef.value) {
    translationAreaContentRef.value.hide();
  }
};

// 插入
const handleInsert = (str: string) => {
  const newValue = inputPropsValue.value + str;
  inputPropsValue.value = newValue;
  // 触发 input 事件
  emit('input', newValue as string);
  // 如果是文案仿写，则关闭气泡窗
  if (copywritingPopoverVisible.value) {
    copywritingPopoverVisible.value = false;
  }
};

// 替换
const handleReplace = (str: string) => {
  inputPropsValue.value = str;
  // 触发 input 事件
  emit('input', str as string);
  // 如果是文案仿写，则关闭气泡窗
  if (copywritingPopoverVisible.value) {
    copywritingPopoverVisible.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_popover, {
          placement: "right",
          width: 400,
          "show-arrow": false,
          trigger: "hover"
        }, {
          reference: _withCtx(() => _cache[8] || (_cache[8] = [
            _createElementVNode("span", { class: "help-btn" }, [
              _createElementVNode("img", { src: _imports_0 }),
              _createElementVNode("span", { class: "highlight-text" }, "万川文案助手"),
              _createElementVNode("span", { class: "beta-tag" }, "Beta")
            ], -1)
          ])),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tipsList.value, (tip, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "tips-item",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "dot" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(tip.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(tip.content), 1)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_popover, {
          placement: "top",
          width: 300,
          "show-arrow": false,
          onShow: handleShowHotContentArea,
          onHide: handleHideHotContentArea,
          trigger: "click",
          "popper-style": "padding: 0;"
        }, {
          reference: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: "right-item",
              type: "text",
              loading: hotAreaLoading.value
            }, {
              default: _withCtx(() => [
                (!hotAreaLoading.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                  : _createCommentVNode("", true),
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "highlight-text" }, "AI 创作", -1))
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(HotContentArea, {
                ref_key: "hotContentAreaRef",
                ref: hotContentAreaRef,
                onShowLoading: _cache[0] || (_cache[0] = ($event: any) => (hotAreaLoading.value = !hotAreaLoading.value)),
                onInsert: handleInsert,
                onReplace: handleReplace
              }, null, 512)
            ])
          ]),
          _: 1
        }),
        false
          ? (_openBlock(), _createBlock(_component_el_popover, {
              key: 0,
              placement: "top",
              width: 300,
              "show-arrow": false,
              visible: copywritingPopoverVisible.value,
              "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((copywritingPopoverVisible).value = $event)),
              trigger: "manual"
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_button, {
                  class: "right-item",
                  type: "text",
                  loading: copywritingAreaLoading.value,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (copywritingPopoverVisible.value = !copywritingPopoverVisible.value))
                }, {
                  default: _withCtx(() => [
                    (!copywritingAreaLoading.value)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                      : _createCommentVNode("", true),
                    _cache[11] || (_cache[11] = _createElementVNode("span", null, "文案仿写", -1))
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(CopywritingArea, {
                    ref_key: "copywritingAreaRef",
                    ref: copywritingAreaRef,
                    onShowLoading: _cache[2] || (_cache[2] = ($event: any) => (copywritingAreaLoading.value = !copywritingAreaLoading.value)),
                    onInsert: handleInsert,
                    onReplace: handleReplace,
                    onClose: _cache[3] || (_cache[3] = ($event: any) => (copywritingPopoverVisible.value = false))
                  }, null, 512)
                ])
              ]),
              _: 1
            }, 8, ["visible"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_el_input, {
      class: "ai-input-content custom-el-input-textarea",
      type: _ctx.type,
      modelValue: inputPropsValue.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((inputPropsValue).value = $event)),
      placeholder: _ctx.placeholder,
      disabled: _ctx.disabled,
      maxlength: _ctx.maxlength,
      rows: _ctx.rows,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onInput: handleInput
    }, null, 8, ["type", "modelValue", "placeholder", "disabled", "maxlength", "rows"]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        false
          ? (_openBlock(), _createBlock(_component_el_popover, {
              key: 0,
              placement: "top",
              width: 300,
              "show-arrow": false,
              ref: "translationAreaRef",
              onShow: handleShowTranslationArea,
              onHide: handleHideTranslationArea,
              trigger: "click"
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_button, {
                  class: "right-item",
                  type: "text",
                  loading: translationAreaLoading.value
                }, {
                  default: _withCtx(() => [
                    (!translationAreaLoading.value)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(TranslationArea, {
                    ref_key: "translationAreaContentRef",
                    ref: translationAreaContentRef,
                    onInsert: handleInsert,
                    onReplace: handleReplace,
                    onShowLoading: _cache[6] || (_cache[6] = ($event: any) => (translationAreaLoading.value = !translationAreaLoading.value))
                  }, null, 512)
                ])
              ]),
              _: 1
            }, 512))
          : _createCommentVNode("", true),
        _createVNode(_component_el_popover, {
          placement: "top",
          width: 300,
          "show-arrow": false,
          ref_key: "polishAreaContentRef",
          ref: polishAreaContentRef,
          onShow: handleShowPolishArea,
          onHide: handleHidePolishArea,
          trigger: "click"
        }, {
          reference: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: "right-item",
              type: "text",
              loading: polishAreaLoading.value
            }, {
              default: _withCtx(() => [
                (!polishAreaLoading.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(PolishAreaContent, {
                ref_key: "polishAreaContentRef",
                ref: polishAreaContentRef,
                onInsert: handleInsert,
                onReplace: handleReplace,
                onShowLoading: _cache[7] || (_cache[7] = ($event: any) => (polishAreaLoading.value = !polishAreaLoading.value))
              }, null, 512)
            ])
          ]),
          _: 1
        }, 512)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("span", _hoisted_19, [
          _createElementVNode("span", null, "共 " + _toDisplayString(textLength.value) + " 字", 1),
          _createElementVNode("span", null, "预计阅读时间 " + _toDisplayString(readingTime.value) + " 秒", 1)
        ])
      ])
    ])
  ]))
}
}

})